import DateService from 'live/services/date'

export const DATE_FORMAT = DateService.getDateFormat()
export const DATE_TIME_FORMAT = `${DateService.getDateFormat()} ${DateService.getTimeShort()}`

export const isDateString = (dateString: string) => !!Date.parse(dateString)
